/**
 * Authenticated fetch wrapper - automatically includes Bearer token
 */
const TOKEN_KEY = 'trove_helix_token';

export function authFetch(url, options = {}) {
  const token = localStorage.getItem(TOKEN_KEY);
  const headers = { ...(options.headers || {}) };
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  if (options.method && options.method !== 'GET' && options.body && !headers['Content-Type']) {
    headers['Content-Type'] = 'application/json';
  }
  return fetch(url, { ...options, headers });
}
